import { render, staticRenderFns } from "./profile-page.vue?vue&type=template&id=948dd728"
import script from "./profile-page.vue?vue&type=script&lang=js"
export * from "./profile-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports